// src/pages/BeautyStationInfo.js
import React, { useState } from 'react';
import '../style/BeautyStationInfo.css'; // Import the CSS file for styling

const BeautyStationInfo = () => {
  const [email, setEmail] = useState('');
  const [fullName, setFullName] = useState('');
  const [whatsapp, setWhatsapp] = useState('');
  const [socialUser, setSocialUser] = useState('');
  const [course, setCourse] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    e.target.submit(); // Submit the form
  };

  return (
    <div className="form-container">
        <div className='image'>
        <img className="main-image" src={`${process.env.PUBLIC_URL}/Main.png`} alt="Main Imagen for Form"/>
        </div>
      <h2>QUIERO ENTERARME DE LOS PRÓXIMOS TALLERES Y CURSOS</h2>
      <form
        action="https://docs.google.com/forms/u/0/d/e/1FAIpQLSdcKl-WSuk0GMxZhFK89STcHmi9ebu-r-2TwNFiTeSA1BF7rA/formResponse"
        method="post"
        onSubmit={handleSubmit}
      >
        <label htmlFor="email">Email:*</label>
        <input
          type="email"
          id="email"
          name="emailAddress"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="email@domain.com"
          required
        />
        <br />

        <label htmlFor="fullName">Nombre Completo:*</label>
        <input
          type="text"
          id="fullName"
          name="entry.1602240111"
          value={fullName}
          onChange={(e) => setFullName(e.target.value)}
          required
        />
        <br />

        <label htmlFor="whatsapp">Número de Whatsapp:*</label>
        <input
          type="text"
          id="whatsapp"
          name="entry.1691432624"
          value={whatsapp}
          onChange={(e) => setWhatsapp(e.target.value)}
          placeholder="XXXX-XXXX"
          required
        />
        <br />

        <label htmlFor="socialUser">Usuario de Instagram o Facebook:*</label>
        <input
          type="text"
          id="socialUser"
          name="entry.188611796"
          value={socialUser}
          onChange={(e) => setSocialUser(e.target.value)}
          required
        />
        <br />

        <label htmlFor="course">Cursos:*</label>
        <select
          id="course"
          name="entry.1741086219"
          value={course}
          onChange={(e) => setCourse(e.target.value)}
          required
        >
          <option value="">Select a course</option>
          <option value="MAQUILLAJE">Maquillaje</option>
          <option value="PEINADO">Peinado</option>
          <option value="AMBOS">Ambos</option>
        </select>
        <br />

        <input type="submit" value="Submit" />
      </form>
    </div>
  );
};

export default BeautyStationInfo;
